import 'muse-ui/dist/muse-ui.css'
import 'muse-ui/dist/theme-light.css'
import 'oocss-utils/utils.css'
import '@/assets/css/index.css'
import Vue from 'vue'
import MuseUI from 'muse-ui'

// 引用 MuseUI
Vue.use(MuseUI)

import MuDatePicker from './MuDatePicker'
import BackTop from './BackTop'
import MuRadio from './MuRadio'

mixins({
	'mu-date-picker': MuDatePicker,
	'mu-back-top': BackTop,
	'mu-radio': MuRadio
})

export default function mixins (mixinsObj) {
	for (var key in mixinsObj) {
		Vue.component(key).mixin(mixinsObj[key])
	}
}





// WEBPACK FOOTER //
// ./src/components/mixins/index.js